import React, { useState } from "react";
import "./Ventures.scss";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa6";

// --- HYDERABAD ---
//import MapImage from "../../../assets/images/img/Hyd-Location.png";
//import DocumentsImage from "../../../assets/images/img/Sai Akshara Documents.pdf";
import BrochureImage from "../../../assets/images/img/Sai Akshara Brochure.jpg";
//import CustomerAppImage from "../../../assets/images/img/Sai Akshara Application.pdf";

import HyderabadBhanuLocation from "../../../assets/images/img/Sai Bhanu Location.jpeg";
import HyderabadBhanuDocument from "../../../assets/images/img/Sai Bhanu  Documents.pdf";
import HyderabadBhanuBrochure from "../../../assets/images/img/Sai Bhanu Brochure.jpeg";
import HyderabadBhanuCustomerApp from "../../../assets/images/img/Sai Bhanu Application.pdf";

import HyderabadBhuvanaLocation from "../../../assets/images/img/Sai Bhanu Location.jpeg";
import HyderabadBhuvanaDocument from "../../../assets/images/img/Sai Bhuvana  Documents.pdf";
import HyderabadBhuvanaBrochure from "../../../assets/images/img/Sai Bhanu Brochure.jpeg";
import HyderabadBhuvanaCustomerApp from "../../../assets/images/img/Sai Bhuvana  Application.pdf"; 

import HyderabadDhariniLocation from "../../../assets/images/img/Sai Bhanu Location.jpeg";
import HyderabadDhariniDocument from "../../../assets/images/img/Sai Dharini  Documents.pdf";
import HyderabadDhariniBrochure from "../../../assets/images/img/Sai Bhanu Brochure.jpeg";
import HyderabadDhariniCustomerApp from "../../../assets/images/img/Sai Dharini Application.pdf";

// import HyderabadRenukaLocation from "../../../assets/images/img/Sai Renuka Location.jpeg";
// import HyderabadRenukaDocument from "../../../assets/images/img/Sai Renuka Documents.jpeg";
// import HyderabadRenukaBrochure from "../../../assets/images/img/Sai Renuka Brochure.jpeg";
// import HyderabadRenukaCustomerApp from "../../../assets/images/img/Sai Renuka Application.jpeg"; 

// --- VIZAG ---
import VizagMapImage from "../../../assets/images/img/Sai Mahalakshmi location.jpg";
import VizagLayoutDocument from "../../../assets/images/img/Sai Mahalakshmi Documents.pdf";
import VizagBrochureImage from "../../../assets/images/img/Sai Mahalakshmi Brocher.jpg";
import VizagCustomerApp from "../../../assets/images/img/Sai Mahalakshmi Application.pdf";

// import VizagDurgaLocation from "../../../assets/images/img/Sai Durga Location.jpeg";
// import VizagDurgaDocument from "../../../assets/images/img/Sai Durga Documents.jpeg";
// import VizagDurgaBrochure from "../../../assets/images/img/Sai Durga Brochure.jpeg";
// import VizagDurgaCustomerApp from "../../../assets/images/img/Sai Durga Application.jpeg";               

// --- VIJAYAWADA ---
import VijayawadaVigneshLocation from "../../../assets/images/img/Sai Vignesh Locationmap.jpeg";    
import VijayawadaVigneshDocument from "../../../assets/images/img/Sai Vignesh   Documents.pdf";
import VijayawadaVigneshBrochure from "../../../assets/images/img/Sai Vignesh Brocher.jpeg";
import VijayawadaVigneshCustomerApp from "../../../assets/images/img/Sai Vignesh Application.pdf";

import VijayawadaMahalakshmiLocation from "../../../assets/images/img/Mahalakshmi Vijayawada Location.jpeg";
import VijayawadaMahaDocument from "../../../assets/images/img/Mahalakshmi  Documents.pdf";
import VijayawadaMahalakshmiBrochure from "../../../assets/images/img/Mahalakshmi Vijayawada Brochure.jpeg";
import VijayawadaMahalakshmiCustomerApp from "../../../assets/images/img/Mahalakshmi Application.pdf";

import VijayawadaVaibhavLocation from "../../../assets/images/img/Sai Vaibhav Location.jpeg";
import VijayawadaVaibhavDocument from "../../../assets/images/img/Sai Vaibhav Documents.pdf";
import VijayawadaVaibhavBrochure from "../../../assets/images/img/Sai Vaibhav Brochure.jpeg";
import VijayawadaVaibhavCustomerApp from "../../../assets/images/img/Sai Vaibhav Application.pdf";

// import VijayawadaDwarakaLocation from "../../../assets/images/img/Sai Dwaraka Location.jpeg";
// import VijayawadaDwarakaDocument from "../../../assets/images/img/Sai Dwaraka Documents.jpeg";
// import VijayawadaDwarakaBrochure from "../../../assets/images/img/Sai Dwaraka Brochure.jpeg";
// import VijayawadaDwarakaCustomerApp from "../../../assets/images/img/Sai Dwaraka Application.jpeg";

// --- GUNTUR ---
import GunturAbhayaLocation from "../../../assets/images/img/Sai Abhaya Loaction.jpeg";
import GunturAbhayaDocument from "../../../assets/images/img/Sai Abhaya Documents.pdf";
import GunturAbhayaBrochure from "../../../assets/images/img/Sai Abhaya Brochure.jpeg";
import GunturAbhayaCustomerApp from "../../../assets/images/img/Sai Abhaya Application.pdf";

import GunturVenkatLocation from "../../../assets/images/img/Sai Venkat Loaction.jpeg";
import GunturVenkatDocument from "../../../assets/images/img/Sai Venkat Documents.pdf";
import GunturVenkatBrochure from "../../../assets/images/img/Sai Venkat Brochure.jpeg";
import GunturVenkatCustomerApp from "../../../assets/images/img/Sai Venkat Application.pdf";

import UnderConstructionImage from "../../../assets/images/img/under_construction.jpeg";
import ApplicationForm from "./ApplicationForm";

const LABELS = [
  "Location map",
  "Brochure",
  "Documents",
  "Customer Application",
  "Application",
];

const MAP_LINKS = {
  "Sai Akshara": "https://maps.app.goo.gl/XFDwzGFLgBELn4Mh8",
  "Sai Bhanu": "https://maps.app.goo.gl/Jf5pRRwqDXRaaVDM9",
  "Sai Bhuvana": "https://maps.app.goo.gl/D7hm8KgoSbZwHT768",
  "Sai Dharini": "https://maps.app.goo.gl/yBQ8yixM5gtHWF199",
  "Sai Renuka": "https://maps.app.goo.gl/8thTufGeTBZNqPAHA",
  "Sai Mahalakshmi Phase-2": "https://maps.app.goo.gl/xn3M1DS39ZtBJrP37",
  "Sai Durga": "https://maps.app.goo.gl/xn3M1DS39ZtBJrP37",
  "Sai Vignesh": "https://maps.app.goo.gl/68c2C5N1kXcspFDv8",
  "Sai Vaibhav": "https://maps.app.goo.gl/DYJLcBrwt81mANjT7",
  "Sai Mahalakshmi": "https://maps.apple.com/?auid=3441633144404108541&ll=16.370692,80.875360&lsp=7618&q=Dropped%20Pin&t=h",
  "Sai Dwaraka": "https://maps.apple.com/?auid=3441633144404108541&ll=16.370692,80.875360&lsp=7618&q=Dropped%20Pin&t=h",
  "Sai Abhaya": "https://maps.app.goo.gl/GhHrTTHezFnWzafJA",
  "Sai Venkat (Premium)": "https://maps.app.goo.gl/vgha5sEy9y8M4sWc7?g_st=aw",
};

function getBranches(cityLabel, branchNames = []) {
  return branchNames.map((name, i) => {
    let customImages = {
      "Location map": MAP_LINKS[name] || null, 
      "Brochure": null,
      "Documents" : null,
      "Customer Application": null,
    };

    // --- Hyderabad branches ---
    if (cityLabel === "Hyderabad" && i === 0 && name === "Sai Akshara") {
      customImages = {
        ...customImages,
        "Brochure": BrochureImage,
        //"Documents" : DocumentsImage,
        //"Customer Application": CustomerAppImage,
      };
    } 
    else if (cityLabel === "Hyderabad" && name === "Sai Bhanu") {
      customImages = {
        ...customImages,
        // "Location map": HyderabadBhanuLocation, 
        "Brochure": HyderabadBhanuBrochure,
        "Documents" : HyderabadBhanuDocument,
        "Customer Application": HyderabadBhanuCustomerApp,
      };
    } 
    else if (cityLabel === "Hyderabad" && name === "Sai Bhuvana") {
      customImages = {
        ...customImages,
        // "Location map": HyderabadBhuvanaLocation,
        "Brochure": HyderabadBhuvanaBrochure,
        "Documents" : HyderabadBhuvanaDocument,
        "Customer Application": HyderabadBhuvanaCustomerApp,
      };
    } 
    else if (cityLabel === "Hyderabad" && name === "Sai Dharini") { 
      customImages = {
        ...customImages,
        // "Location map": HyderabadDhariniLocation,
        "Brochure": HyderabadDhariniBrochure,
        "Documents" : HyderabadDhariniDocument,
        "Customer Application": HyderabadDhariniCustomerApp,
      };
    } 
    else if (cityLabel === "Hyderabad" && name === "Sai Renuka") {
      customImages = {
        ...customImages,
        // "Location map": HyderabadRenukaLocation,
        // "Brochure": HyderabadRenukaBrochure,
        // "Documents" : HyderabadRenukaDocument,
        // "Customer Application": HyderabadRenukaCustomerApp,
      };
    } 

    else if (cityLabel === "Vizag" && i === 0 && name === "Sai Mahalakshmi Phase-2") {
      customImages = {
        ...customImages,
        // "Location map": VizagMapImage,
        "Brochure": VizagBrochureImage,
        "Documents" : VizagLayoutDocument,
        "Customer Application": VizagCustomerApp,
      };
    } 
    else if (cityLabel === "Vizag" && name === "Sai Durga") {
      customImages = {
        ...customImages,
        // "Location map": VizagDurgaLocation,
        // "Brochure": VizagDurgaBrochure,
        // "Documents" : VizagDurgaDocument,
        // "Customer Application": VizagDurgaCustomerApp,
      };
    } 

    else if (cityLabel === "Vijayawada" && name === "Sai Vignesh") {
      customImages = {
        ...customImages,
        // "Location map": VijayawadaVigneshLocation,
        "Brochure": VijayawadaVigneshBrochure,
        "Documents" : VijayawadaVigneshDocument,
        "Customer Application": VijayawadaVigneshCustomerApp,
      };
    } 
    else if (cityLabel === "Vijayawada" && name === "Sai Mahalakshmi") {
      customImages = {
        ...customImages,
        // "Location map": VijayawadaMahalakshmiLocation,
        "Brochure": VijayawadaMahalakshmiBrochure,
        "Documents" : VijayawadaMahaDocument,
        "Customer Application": VijayawadaMahalakshmiCustomerApp,
      };
    } 
    else if (cityLabel === "Vijayawada" && name === "Sai Vaibhav") {
      customImages = {
        ...customImages,
        // "Location map": VijayawadaVaibhavLocation,
        "Brochure": VijayawadaVaibhavBrochure,
        "Documents" : VijayawadaVaibhavDocument,
        "Customer Application": VijayawadaVaibhavCustomerApp,
      };
    } 
    else if (cityLabel === "Vijayawada" && name === "Sai Dwaraka") {
      customImages = {
        ...customImages,
        // "Location map": VijayawadaDwarakaLocation,
        // "Brochure": VijayawadaDwarakaBrochure,
        // "Documents" : VijayawadaDwarakaDocument,
        // "Customer Application": VijayawadaDwarakaCustomerApp,
      };
    } 

    else if (cityLabel === "Guntur" && name === "Sai Abhaya") {
      customImages = {
        ...customImages,
        "Brochure": GunturAbhayaBrochure,
        "Documents" : GunturAbhayaDocument,
        "Customer Application": GunturAbhayaCustomerApp,
      };
    } 
    else if (cityLabel === "Guntur" && name === "Sai Venkat (Premium)") {
      customImages = {
        ...customImages,
        "Brochure": GunturVenkatBrochure,
        "Documents" : GunturVenkatDocument,
        "Customer Application": GunturVenkatCustomerApp,
      };
    } 

    return {
      name,
      tabs: {
        "Location map": {
          image: customImages["Location map"],
          content: null,
        },
        "Brochure": {
          image: customImages["Brochure"],
          content: null,
        },
        "Documents": {
          image: customImages["Documents"],
          content: null,
        },
        "Customer Application": {
          image: customImages["Customer Application"],
          content: null,
        },
        "Application": {
          content: null,
        },
      },
    };
  });
}

const CITY_DATA = [
  {
    label: "Hyderabad",
    branches: getBranches("Hyderabad", [
      "Sai Akshara",
      "Sai Bhanu",
      "Sai Bhuvana",
      "Sai Dharini",
      "Sai Renuka",
    ]),
  },
  {
    label: "Vijayawada",
    branches: getBranches("Vijayawada", [
      "Sai Vignesh",
      "Sai Vaibhav",
      "Sai Mahalakshmi",
      "Sai Dwaraka",
    ]),
  },
  {
    label: "Vizag",
    branches: getBranches("Vizag", [
      "Sai Mahalakshmi Phase-2",
      "Sai Durga",
    ]),
  },
  {
    label: "Guntur",
    branches: getBranches("Guntur", [
      "Sai Abhaya",
      "Sai Venkat (Premium)",
    ]),
  },
];

const Ventures = () => {
  const [activeCity, setActiveCity] = useState(0);
  const [activeBranch, setActiveBranch] = useState(0);
  const [activeLabel, setActiveLabel] = useState(0);

  const city = CITY_DATA[activeCity];
  const branch = city.branches[activeBranch] || {};
  const label = LABELS[activeLabel];
  const tabData = branch.tabs?.[label] || {};

  const handleCityChange = (idx) => {
    setActiveCity(idx);
    setActiveBranch(0);
    setActiveLabel(0);
  };

  const handleBranchNext = () => {
    if (activeBranch < city.branches.length - 1) {
      setActiveBranch(activeBranch + 1);
      setActiveLabel(0);
    }
  };

  const handleBranchPrev = () => {
    if (activeBranch > 0) {
      setActiveBranch(activeBranch - 1);
      setActiveLabel(0);
    }
  };

  const renderFileContent = (file, labelName) => {
    const isPDF = file && file.toLowerCase().endsWith(".pdf");
    const isMapLink = labelName === "Location Map" && typeof file === "string" && file.startsWith("http");

    return (
      <div className={`${labelName.toLowerCase().replace(" ", "-")}-content center-content`}>
        {file ? (
          isMapLink ? (
            <a
              href={file}
              target="_blank"
              rel="noopener noreferrer"
              className="view-pdf-btn"
              style={{
                margin: "2rem 0",
                padding: "12px 28px",
                fontSize: "1.05rem",
                display: "inline-block",
                textDecoration: "none",
              }}
            >
              View Location on Map
            </a>
          ) : isPDF ? (
            <>
              <iframe
                src={file}
                title={labelName}
                style={{
                  width: "100%",
                  maxWidth: "850px",
                  height: "900px",
                  border: "none",
                  borderRadius: "10px",
                  boxShadow: "0 2px 16px rgba(0, 0, 0, 0.1)",
                  marginBottom: "1rem"
                }}
              />
              <a
                href={file}
                download
                className="view-pdf-btn"
                style={{
                  margin: "1rem 0",
                  padding: "12px 28px",
                  fontSize: "1.05rem",
                  display: "inline-block",
                  textDecoration: "none",
                }}
              >
                Download PDF
              </a>
            </>
          ) : (
            <img
              src={file}
              alt={labelName}
              style={{
                maxWidth: "850px",
                width: "100%",
                borderRadius: "14px",
                boxShadow: "0 2px 16px rgba(60, 90, 40, 0.1)",
              }}
            />
          )
        ) : (
          <img
            src={UnderConstructionImage}
            alt="Under Construction"
            style={{
              maxWidth: "850px",
              width: "100%",
              borderRadius: "14px",
              boxShadow: "0 2px 16px rgba(60, 90, 40, 0.1)",
            }}
          />
        )}
      </div>
    );
  };

  return (
    <div className="ventures" id="ventures">
      <h2 className="ventures-title">Ventures</h2>

      <div className="venture-tabs">
        {CITY_DATA.map((city, idx) => (
          <button
            key={city.label}
            className={`venture-tab ${activeCity === idx ? "active" : ""}`}
            onClick={() => handleCityChange(idx)}
          >
            {city.label}
          </button>
        ))}
      </div>

      <div className="branch-nav-slider-top">
        <div className="branch-label">{branch.name}</div>
        <div className="branch-slider-arrows">
          <button
            className={`branch-arrow-btn left ${activeBranch === 0 ? "disabled" : ""}`}
            onClick={handleBranchPrev}
            disabled={activeBranch === 0}
          >
            <FaAngleLeft />
          </button>
          <button
            className={`branch-arrow-btn right ${
              activeBranch === city.branches.length - 1 ? "disabled" : ""
            }`}
            onClick={handleBranchNext}
            disabled={activeBranch === city.branches.length - 1}
          >
            <FaAngleRight />
          </button>
        </div>
      </div>

      <div className="branch-label-tabs">
        {LABELS.map((lbl, idx) => (
          <button
            key={lbl}
            className={`branch-label-tab ${activeLabel === idx ? "active" : ""}`}
            onClick={() => setActiveLabel(idx)}
          >
            {lbl}
          </button>
        ))}
      </div>
      <div className="branch-label-content">
        {label === "Location map" && renderFileContent(tabData.image, "Location Map")}
        {label === "Brochure" && renderFileContent(tabData.image, "Brochure")}
        {label === "Documents" && renderFileContent(tabData.image, "Documents")}
        {label === "Customer Application" && renderFileContent(tabData.image, "Customer Application")}

        {label === "Application" && (
          <div className="application-content center-content">
            <ApplicationForm />
          </div>
        )}
      </div>
    </div>
  );
};

export default Ventures;